import { Injectable } from '@angular/core';
import { appConfig } from '../app.config';
import { CommonService } from './common.service';
import { Observable } from 'rxjs';

class SustainModel {
  "companyId": string
  "companyURL": string
  "fileName": string
  "fileType": string
  "fileStatus": string
  "fileEndDate": string
  "lastModification": string
}

@Injectable({
  providedIn: 'root'
})
export class SustainService {
  apiUrl ='';
  constructor(readonly apiService: CommonService) {
    this.apiUrl=appConfig.SustainServiceUrl;
  }

  createSustain(url,data):Observable<SustainModel> {
    return this.apiService.postServiceCall(`${this.apiUrl}/create-sustain`, url,data) as Observable<SustainModel>;
  }
}
